import i18n from '@/lang'

import { extractValue } from '@/utils/maps'

// 产品类型 - 收款  2 bill payment 3 bank transfer 4 qrph
export function payinPaymentMethodMap(value) {
  const map = [
    {
      value: 1,
      label: 'Web Payment'
    },
    {
      value: 2,
      label: 'Bill Payment'
    }, {
      value: 3,
      label: 'Bank Transfer'
    }, {
      value: '4,5',
      label: 'Merchant-presented QR'
    },
    {
      value: 6,
      label: 'Consumer-presented QR'
    }]
  return extractValue(value, map)
}
